"use client";

import AdSlotWrapper from '@/components/AdSlotWrapper';
import TechnologyHeader from './components/TechnologyHeader';
import TechnologyFooter from './components/TechnologyFooter';
import './technology.css';

export default function TechnologyPublicShell({ children, siteSettings = {}, articles = [], pages = [], categories = [] }) {
  return (
    <div className="technology-public min-h-screen w-full bg-white text-black">
      <div className="pointer-events-none fixed inset-0 z-0 flex justify-center overflow-hidden">
        <div className="pointer-events-auto h-full w-full">
          <AdSlotWrapper id="global_skin_ad" className="flex h-full w-full items-center justify-center" settings={siteSettings} />
        </div>
      </div>
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1200px] flex-col bg-white">
        <AdSlotWrapper id="global_top_banner" settings={siteSettings} />
        <TechnologyHeader siteSettings={siteSettings} articles={articles} pages={pages} categories={categories} />
        <main className="relative w-full flex-grow px-4 py-8 md:px-8">{children}</main>
        <TechnologyFooter siteSettings={siteSettings} pages={pages} categories={categories} />
      </div>
    </div>
  );
}
